module.exports = __webpack_public_path__ + "img/2024-3.fc0cc887.jpg";